/**
 * MenuItemCard — Renders a single restaurant menu item card.
 * Uses the same DOM structure and CSS classes as ecommerce ProductCard.
 */
export class MenuItemCard {
  constructor(item, config = {}) {
    this.item = item;
    this.primaryColor = config.primaryColor || '#2563eb';
    this.onSelect = config.onSelect || (() => {});
    this.element = this._render();
  }

  _render() {
    const card = document.createElement('div');
    card.className = 'ttp-product-card';
    card.dataset.itemId = this.item.id;

    const currencySymbol = this.item.currency === 'ILS' ? '₪' : '$';

    const allergenBadges = (this.item.allergens || [])
      .map(a => `<span class="ttp-allergen-tag">${a}</span>`)
      .join('');

    const dietaryTags = (this.item.tags || [])
      .filter(t => ['vegetarian', 'vegan', 'gluten-free', 'healthy'].includes(t))
      .map(t => `<span class="ttp-dietary-tag">${t}</span>`)
      .join('');

    const tagsHTML = (dietaryTags || allergenBadges)
      ? `<div class="ttp-product-tags">${dietaryTags}${allergenBadges}</div>`
      : '';

    card.innerHTML = `
      <div class="ttp-product-image">
        <img src="${this.item.imageUrl || ''}" alt="${this.item.name}" loading="lazy"
             onerror="this.style.display='none'" />
        ${!this.item.available ? '<div class="ttp-stock-badge">Unavailable</div>' : ''}
      </div>
      <div class="ttp-product-details">
        <div class="ttp-product-name">${this.item.name}</div>
        <div class="ttp-product-meta">${this.item.category || ''}</div>
        ${tagsHTML}
        <div class="ttp-product-footer">
          <span class="ttp-product-price">${currencySymbol}${(this.item.price || 0).toFixed(2)}</span>
          ${this.item.available
            ? `<button class="ttp-add-btn">Add</button>`
            : '<span class="ttp-out-of-stock">Unavailable</span>'}
        </div>
      </div>
    `;

    const btn = card.querySelector('.ttp-add-btn');
    if (btn && this.item.available) {
      btn.style.background = this.primaryColor;
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        btn.textContent = '✓';
        btn.classList.add('ttp-added');
        btn.disabled = true;
        this.onSelect(this.item);
        setTimeout(() => {
          btn.textContent = 'Add';
          btn.classList.remove('ttp-added');
          btn.disabled = false;
        }, 1500);
      });
    }

    return card;
  }
}
